import { useCallback } from 'react';
import { isMissionsApiSuccess, getMissionsErrorMessage } from '../../services/missionsApi';

export function useMissionsSession(setError) {
  const handleApiResponse = useCallback(
    (res, fallback) => {
      if (!isMissionsApiSuccess(res)) {
        setError(getMissionsErrorMessage(res, fallback));
        return true;
      }
      return false;
    },
    [setError]
  );

  return { handleApiResponse };
}
